import React, { useState, MouseEvent } from "react";

import Observer from '@researchgate/react-intersection-observer';

import Draggable from 'react-draggable';

import { ReactComponent as Menu1 } from '@assets/images/section-2/menu-1.svg';
import { ReactComponent as Menu2 } from '@assets/images/section-2/menu-2.svg';

import { ReactComponent as Menu1Mob } from '@assets/images/section-2/menu-1-mob.svg';
import { ReactComponent as Menu2Mob } from '@assets/images/section-2/menu-2-mob.svg';

import { ReactComponent as MenuNumber } from '@assets/images/section-2/menu-number.svg';

import { ReactComponent as Zoom } from '@assets/images/section-2/zoom-lens.svg';
import { ReactComponent as MenuClose } from '@assets/images/menu/menu-close.svg';

import Map1 from '@assets/images/section-2/map-1.webp';
import Map1Safari14 from '@assets/images/section-2/map-1-safari-14.jpg';

import styles from './index.module.css';

type PageProps = {
  scrollDir?: string;
  isDesktopOrLaptop?: any;
  browser: any;
};

export const Page2: React.FC<PageProps> = ({ ...props }) => {
  const [isVisible, setVisible] = useState([false]);
  const [isOpenLightbox, setOpenLightbox] = useState(false);
  const { scrollDir, isDesktopOrLaptop, browser } = props;

  const handleChange = (event: any | never, index: number) => {
    const currActive = isVisible[index];
    const updateArr = [ ...isVisible ];
    updateArr[index] = event.isIntersecting || (currActive && scrollDir === 'down')
    setVisible(updateArr);
  };

  const toggleLightBox = (e: any) => {
    e.preventDefault();
    setOpenLightbox(!isOpenLightbox);
  };

  const browserName = browser.name.toLowerCase();
  const browserVersion = browser.version.split('.')[0];

  return (
    <Observer
      onChange={event => handleChange(event, 0)}
      root={null}
      rootMargin="0% 0% -20%"
    >
      <article
        id="map"
        className={`
          ${isVisible[0] ? styles.active : ``}
          ${styles.section}
          relative
          max-w-1100
          w-full
          mx-auto
          text-white
          mb-26
          lg:mb-47
        `}
      >
        <header
          className={`
            flex
            lg:inline-flex
            justify-between
            lg:justify-start
            relative
            -mt-8
            lg:mt-0
            pt-8
            lg:pt-0
            pb-13.5
            pl-8
            mr-4
            lg:pl-0
            lg:mr-0

            overflow-hidden
            lg:overflow-visible
          `}
        >
          <h1
            className={`
              inline-flex
              flex-col
              items-stretch
              lg:items-start
              relative
              font-bold
              min-w-full
              lg:min-w-0

              text-4.78xl
              lg:text-6.5xl
            `}
          >
            <span
              className={`
                relative
                transform
                duration-500
                transition-all
              `}
            >
              <span className={`relative`}>Карта</span>
            </span>
            <span
              className={`
                relative
                transform
                duration-500
                transition-all
              `}
            >
              {isDesktopOrLaptop ?
                <Menu1
                  className={`
                    ${styles.menubg1}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    -ml-8
                    mt-3
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
              :
                <Menu1Mob
                  className={`
                    ${styles.menubg1}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    -ml-5
                    mt-2
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
              }
              <span className={`relative -ml-6 lg:-ml-10`}>«Северного</span>
            </span>
            <span
              className={`
                relative
                transform
                duration-500
                delay-700
                transition-all
              `}
            >
              {isDesktopOrLaptop ?
                <Menu2
                  className={`
                    ${styles.menubg2}
                    absolute
                    transform
                    duration-500
                    transition-all
                    mt-2
                    -ml-6
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
                :
                <Menu2Mob
                  className={`
                    ${styles.menubg2}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    -ml-1
                    mt-2
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
              }
              <span className={`relative`}>потока-2»</span>
            </span>
          </h1>
          <h2 className={`
            absolute
            top-0
            lg:-top-8
            right-0
            lg:-right-8
            z-2
          `}>
            <MenuNumber
              width={isDesktopOrLaptop ? 176 : 140}
              height={isDesktopOrLaptop ? 230 : 182}
              className={`
                ${styles.number1}
                relative
                fill-current
              `}
            />
            <MenuNumber
              width={isDesktopOrLaptop ? 176 : 140}
              height={isDesktopOrLaptop ? 230 : 182}
              className={`
                ${styles.number2}
                absolute
                top-0
                right-0
                fill-current
              `}
            />
          </h2>
        </header>

        <Observer
          onChange={event => handleChange(event, 1)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div className={`max-w-890 mx-8 lg:mx-auto mb-10 lg:mb-22vw`}>
            <div
              className={`
                flex
                flex-col
                lg:flex-row
                w-full
                mb-13.5
                lg:mb-0
              `}
            >
              <div
                className={`
                  ${isVisible[1]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                  mb-11
                  lg:mb-0
                `}
              >
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:mr-11.5
                  `}
                >
                  «Северный поток» — часть магистрального газопровода между Россией и Германией, проходящего по дну Балтийского моря. <span className={`text-blue-default font-bold`}>Свое начало он берет недалеко от российского города Выборг и доходит до немецкого Грайфсвальда.</span>
                </span>
              </div>
              <div
                className={`
                  ${isVisible[1]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full
                  animation-delay-500

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                  mt-0
                  lg:mt-30vw
                `}
              >
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:ml-11.5
                  `}
                >
                  Его первую нитку запустили в ноябре 2011 года, а вторую — в октябре 2012-го. <span className={`text-blue-default font-bold`}>«Северный поток» — самый протяжённый подводный газопровод в мире: его длина — 1 224 км, а мощность 55 млрд кубометров газа в год.</span> Разрешение на запуск газопровода Федеральное сетевое агентство Германии может дать уже в начале 2022 года.
                </span>
              </div>
            </div>
          </div>
        </Observer>

        {isOpenLightbox &&
          <div
            className={`
              ${isVisible[2]? `animate-opacity` : ``}
              transform
              opacity-0
              translate-y-full

              fixed
              top-0
              left-0
              w-full
              h-screen
              bg-background-color
              bg-opacity-40
              flex
              justify-center
              items-center
              overflow-auto
              z-7

              max-w-890
              mx-auto
              mb-13
              lg:mb-30vw
            `}
            onClick={e => !isDesktopOrLaptop && toggleLightBox(e)}
          >

            <Draggable>
              <img
                className={`
                  min-h-545
                  min-w-884
                  transform
                  translate-all
                  max-w-full
                  h-auto
                `}
                src={(browserName === 'safari' && browserVersion < 15) ? Map1Safari14 : Map1}
                width="1080"
                height="665"
                alt=""
              />
            </Draggable>

            {!isDesktopOrLaptop && <span
              onClick={toggleLightBox}
              className={`
                cursor-pointer
                bg-background-color
                bg-opacity-80
                ${isOpenLightbox ? `fixed` : `absolute`}
                top-0
                right-0
                w-9
                h-9
                flex
                justify-center
                items-center
              `}
            >
              <MenuClose className={`text-white fill-current`} width={18} height={18} />
            </span>}
          </div>
        }
        <Observer
          onChange={event => handleChange(event, 2)}
          root={null}
          rootMargin="0% 0% 20%"
        >

          <div
            className={`
              ${isVisible[2]? `animate-opacity` : ``}
              transform
              opacity-0
              translate-y-full
              z-2

              relative

              max-w-890
              mx-auto
              mb-13
              lg:mb-30vw
            `}
            onClick={e => !isDesktopOrLaptop && toggleLightBox(e)}
          >

            <img
              className={`
                transform
                translate-all
                max-w-full
                h-auto
              `}
              src={(browserName === 'safari' && browserVersion < 15) ? Map1Safari14 : Map1}
              width="1080"
              height="665"
              alt=""
            />

            {!isDesktopOrLaptop && <span
              onClick={toggleLightBox}
              className={`
                cursor-pointer
                bg-background-color
                bg-opacity-80
                ${isOpenLightbox ? `fixed` : `absolute`}
                top-0
                right-0
                w-9
                h-9
                flex
                justify-center
                items-center
              `}
            >
              <Zoom width={22} height={22} />
            </span>}
            <span
              className={`
                hidden
                lg:flex
                justify-center
                mt-7
                text-sm
                italic
                text-blue-default
              `}
            >
              Схема газопровода «Северный поток-2»
            </span>
          </div>
          
        </Observer>

        <Observer
          onChange={event => handleChange(event, 3)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div className={`max-w-890 mx-8 lg:mx-auto lg:mb-22vw`}>
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[3]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                `}
              >
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:mr-13
                  `}
                >
                  На карте изображены два газопровода из России в Европу через Балтийское море — «Северный поток» и его «близнец» — «Северный поток-2». <span className={`text-blue-default font-bold`}>Решение о строительстве второго газопровода было принято исходя из успешного опыта строительства и эксплуатации первого.</span> Длина «СП-2» больше предшественника на 10 км за счёт обхода территориальных вод Дании. <span className={`text-blue-default font-bold`}>Суммарная проектная мощность «Северного потока» и «Северного потока — 2» составляет 110 млрд куб. м газа в год.</span>
                </span>
              </div>
              <div className={`flex-1`} />
            </div>
          </div>
        </Observer>

      </article>
    </Observer>
  );
}